/* eslint-disable max-nested-callbacks */

import { UserType } from 'src/graphql';

/**
 * Checks if user has any of the required permissions
 * Uses Set for O(1) lookup instead of O(n) includes()
 */
export const permissionsCheck = (
  userPermissions: string[],
  requiredPermissions: string[],
): boolean => {
  if (userPermissions.length === 0 || requiredPermissions.length === 0) {
    return false;
  }

  const userPermissionSet = new Set(userPermissions);
  for (const permission of requiredPermissions) {
    if (!userPermissionSet.has(permission)) {
      return false;
    }
  }
  return true;
};

/**
 * Efficiently extracts all user permissions from nested account/role structure
 * Single pass through data with minimal array allocations
 */
export const getAllUserPermissions = (user: UserType): string[] => {
  if (!user) return [];

  // Get accounts array - handle both possible property names
  const accounts = user.accounts ?? user.Accounts;
  if (!accounts?.length) return [];

  const permissions: string[] = [];

  // Single pass through all nested structures
  for (const account of accounts) {
    const roles = account?.Roles;
    if (!roles?.length) continue;

    for (const role of roles) {
      const systemPermissions = role.SystemPermissions;
      if (!systemPermissions?.length) continue;

      for (const permission of systemPermissions) {
        if (permission?.permission) {
          permissions.push(permission.permission);
        }
      }
    }
  }

  // Remove duplicates efficiently using Set
  return permissions.length > 0 ? [...new Set(permissions)] : [];
};
